import Coupon, { CouponProps } from "./Coupon";

export { Coupon, CouponProps };

export default Coupon;
